export enum AuftragArt {
  REGRESSPRUEFUNG = 'REGRESSPRUEFUNG',
  ABFINDUNGSANGEBOT = 'ABFINDUNGSANGEBOT',
  MEDIZINISCHE_EXPERTISE = 'MEDIZINISCHE_EXPERTISE',
  PFLEGERISCHE_EXPERTISE = 'PFLEGERISCHE_EXPERTISE',
  RESERVE = 'RESERVE',
  ESE = 'ESE',
  ATTEST = 'ATTEST',
  GUTACHTEN_AKTENLAGE = 'GUTACHTEN_AKTENLAGE',
  GUTACHTEN_VORSTELLUNG = 'GUTACHTEN_VORSTELLUNG',
  GUTACHTEN_STELLUNGNAHME = 'GUTACHTEN_STELLUNGNAHME',
  ANDERE_ANFRAGE = 'ANDERE_ANFRAGE',
}

export const GUTACHTEN_AUFTRAGSARTEN = new Set<AuftragArt>([
  AuftragArt.GUTACHTEN_AKTENLAGE,
  AuftragArt.GUTACHTEN_VORSTELLUNG,
  AuftragArt.GUTACHTEN_STELLUNGNAHME,
]);

export const GUTACHTEN_AUFTRAGSARTEN_STRINGS = new Set<string>(
  GUTACHTEN_AUFTRAGSARTEN.keys().map((a) => a.toString()),
);
